/*
 * @Author: Teemo Ding
 * @Date: 2021-09-15 12:57:17
 * @LastEditTime: 2021-10-12 16:09:57
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelDomain/Edit/SSLCertificate/index.tsx
 */
import {
  Alert,
  Button,
  Checkbox,
  Label,
  TextArea,
} from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Icon } from '@/src/tools/icon';
import {
  SSLStatusType,
  EnumStatus,
  SSLErrorCodes,
} from '@/src/types/common/domain';
import { Collapse, Form } from 'antd';
import moment from 'moment';
import React, { useState } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { sslValid, sslKeyValid } from 'src/tools/regExp';
import {
  i18nGet,
  replaceI18nVariables,
  handleOnGetCurrentSCDateFormat,
} from 'src/tools/tools';
import css from '../css.module.less';

const { Item } = Form;
const { Panel } = Collapse;

const SSLCertificate = ({
  domain,
  certificate,
  domainStatus,
  confirmDomain,
  cancelSubmission,
  uploadCertificateStatus,
  errorCode,
  errorMsg,
  success,
  btnDisableWhileReq,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [fold, setFold] = useState(false);
  const [isAlertVisible, setIsAlertVisible] = useState(true);
  const {
    verifiedDate = '',
    expireDate = '',
    status = '',
    remindExpire = false,
  } = certificate || {};
  const disabledAll = status == SSLStatusType.Pending || !domain;
  const deletingStatus = domainStatus === EnumStatus.Deleting;
  const dataformat = handleOnGetCurrentSCDateFormat() || 'MMM DD, YYYY';

  const renderAlert = (
    statusItem,
    success,
    errorCode = 0,
    errorMsg,
    remindExpire?,
  ) =>
    statusItem == SSLStatusType.Pending ||
    (statusItem == SSLStatusType.Invalid && isAlertVisible) ||
    statusItem == SSLStatusType.Expired ||
    remindExpire ? (
      <Alert
        className={css.certificateAlert}
        {...(statusItem == SSLStatusType.Pending
          ? {
              action: (
                <Button className={css.infoType} onClick={cancelSubmission}>
                  {getI18n('salesChannelDomainAndStatus.edit.cancelSubmission')}
                </Button>
              ),
            }
          : {})}
        closable={statusItem == SSLStatusType.Invalid ? true : false}
        onClose={() => {
          setIsAlertVisible(false);
        }}
        message={
          statusItem == SSLStatusType.Pending
            ? getI18n('salesChannelDomainAndStatus.edit.certificateProcessing')
            : statusItem == SSLStatusType.Expired || remindExpire
            ? getI18n(
                'salesChannelDomainAndStatus.edit.sSLCertificateexpiressoon',
              )
            : getI18n('salesChannelDomainAndStatus.edit.sSLCertificateInvalid')
        }
        showIcon
        type={statusItem == SSLStatusType.Pending ? 'info' : 'error'}
        icon={
          <Icon
            type={
              statusItem == SSLStatusType.Pending ? 'iconpending' : 'iconfailed'
            }></Icon>
        }
        description={
          statusItem == SSLStatusType.Pending ? (
            getI18n('salesChannelDomainAndStatus.edit.certificateProcessingDes')
          ) : statusItem == SSLStatusType.Expired || remindExpire ? (
            getI18n(
              'salesChannelDomainAndStatus.edit.sSLCertificateexpiressoondesc',
            )
          ) : (
            <>
              {getI18n(
                'salesChannelDomainAndStatus.edit.sSLCertificateInvalidDesc',
              )}
              <br />
              {!success && SSLErrorCodes.includes(errorCode) ? (
                errorMsg ? (
                  getI18n(`salesChannelDomainAndStatus.error.${errorCode}`) +
                  ':' +
                  errorMsg
                ) : (
                  getI18n(`salesChannelDomainAndStatus.error.${errorCode}`)
                )
              ) : (
                <></>
              )}
            </>
          )
        }
      />
    ) : null;

  const renderItem = (
    <div>
      {renderAlert(uploadCertificateStatus, success, errorCode, errorMsg)}
      <div className={css.certificate}>
        <Item
          name={['certificate', 'certificate']}
          className={css.certificateItem}
          label={
            <Label
              title={`${getI18n(
                'salesChannelDomainAndStatus.edit.certificate',
              )}*`}
            />
          }
          rules={[
            {
              required: true,
              message: replaceI18nVariables(
                getI18n('general.fieldisrequired'),
                getI18n('salesChannelDomainAndStatus.edit.certificate'),
              ),
            },
            {
              pattern: sslValid,
              message: getI18n(
                'salesChannelDomainAndStatus.edit.validcertificate',
              ),
            },
          ]}
          labelCol={{ span: 24 }}>
          <TextArea disabled={disabledAll} size='large' />
        </Item>
        <Item
          name={['certificate', 'primaryKey']}
          className={css.certificateItem}
          rules={[
            {
              required: true,
              message: replaceI18nVariables(
                getI18n('general.fieldisrequired'),
                getI18n('salesChannelDomainAndStatus.edit.privateKey'),
              ),
            },
            {
              pattern: sslKeyValid,
              message: getI18n(
                'salesChannelDomainAndStatus.edit.validprivatekey',
              ),
            },
          ]}
          label={
            <Label
              title={`${getI18n(
                'salesChannelDomainAndStatus.edit.privateKey',
              )}*`}
            />
          }
          labelCol={{ span: 24 }}>
          <TextArea disabled={disabledAll} size='large' />
        </Item>
      </div>

      <Item
        name={['certificate', 'certificateAuthorityBundle']}
        className={css.certificateItem}
        label={
          <Label
            title={getI18n(
              'salesChannelDomainAndStatus.edit.certificateAuthorityBundle',
            )}
          />
        }
        rules={[
          {
            pattern: sslValid,
            message: getI18n('salesChannelDomainAndStatus.edit.validbundle'),
          },
        ]}
        labelCol={{ span: 24 }}>
        <TextArea disabled={disabledAll} size='large' />
      </Item>
      <Item name={['certificate', 'notify']} valuePropName='checked'>
        <Checkbox disabled={disabledAll}>
          {getI18n('salesChannelDomainAndStatus.edit.certificatenotifylabel')}
        </Checkbox>
      </Item>
      <Button
        type='primary'
        onClick={async () => {
          await confirmDomain([
            ['certificate', 'certificate'],
            ['certificate', 'primaryKey'],
            ['certificate', 'certificateAuthorityBundle'],
            ['certificate', 'notify'],
            ['domain'],
          ]).then(() => {
            setIsAlertVisible(true);
          });
        }}
        disabled={disabledAll || deletingStatus || btnDisableWhileReq}
        className={css.primaryButton}>
        {getI18n('salesChannelDomainAndStatus.edit.submit')}
      </Button>
    </div>
  );

  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      titleOnClick={() => setFold(!fold)}
      rightPart={<Icon type={fold ? 'icondown1' : 'iconright'}></Icon>}
      hideContent={!fold}
      title={getI18n(
        'salesChannelDomainAndStatus.edit.secureSocketsLayerSSLCertificate',
      )}>
      {renderAlert(status, success, errorCode, errorMsg, remindExpire)}
      {status == SSLStatusType.Verified && (
        <div className={css.certificateVerified}>
          <p className={css.certificateTitle}>
            {getI18n('salesChannelDomainAndStatus.edit.sSLCertificateVerified')}
          </p>
          <p className={css.verifiedData}>
            {verifiedDate &&
              `${getI18n(
                'salesChannelDomainAndStatus.edit.verifiedon',
              )} ${moment(verifiedDate).format(dataformat)}`}
            {expireDate &&
              `, ${getI18n('salesChannelDomainAndStatus.edit.expireson')}
            ${moment(expireDate).format(dataformat)}`}
          </p>
        </div>
      )}

      {status ? (
        <Collapse className={css.collapse} ghost>
          <Panel
            key='1'
            header={getI18n(
              'salesChannelDomainAndStatus.edit.updateSSLCertificate',
            )}>
            {renderItem}
          </Panel>
        </Collapse>
      ) : (
        renderItem
      )}
    </SectionWrapper>
  );
};

export default SSLCertificate;
